module.exports = "/_next/static/images/90f3999da3c8905748853165d4f7b39c-nubank-outdoor-lg@2x.jpg";